// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SuccessMessage } from '@interfaces/interfaces';
import { SuccessModalComponent } from '../modals/success-modal/success-modal.component';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SuccessModalService {
    constructor(private dialog: MatDialog) {}

    showSuccess(success: SuccessMessage): Observable<any> {
        return this.dialog
            .open(SuccessModalComponent, {
                width: '700px',
                closeOnNavigation: false,
                data: success,
            })
            .afterClosed();
    }
}
